import { createSlice } from '@reduxjs/toolkit';

export interface NavbarSearchState {
    open: boolean;
    isHseDesigner: boolean;
}

export const navbarSearchSlice = createSlice({
    name: 'navbarSearch',
    initialState: {
        open: undefined,
        isHseDesigner: true,
    },
    reducers: {
        setNavbarSearchToggle: (state, action) => {
            state.open = action.payload.data;
        },
        setDesignerType:  (state, action) => {
            state.isHseDesigner = action.payload;
        },
    },
});

export default navbarSearchSlice
export const NavbarSearchActions = navbarSearchSlice.actions
export const NavbarSearchSelector = (store: { navbarSearch: NavbarSearchState }): NavbarSearchState => store.navbarSearch;
import { createSlice } from '@reduxjs/toolkit';

export interface NavbarSearchState {
    open: boolean;
    isHseDesigner: boolean;
}

export const navbarSearchSlice = createSlice({
    name: 'navbarSearch',
    initialState: {
        open: undefined,
        isHseDesigner: true,
    },
    reducers: {
        setNavbarSearchToggle: (state, action) => {
            state.open = action.payload.data;
        },
        setDesignerType:  (state, action) => {
            state.isHseDesigner = action.payload;
        },
    },
});

export default navbarSearchSlice
export const NavbarSearchActions = navbarSearchSlice.actions
export const NavbarSearchSelector = (store: { navbarSearch: NavbarSearchState }): NavbarSearchState => store.navbarSearch;
